export const STORE_RESTAURANT_DETAILS = "STORE_RESTAURANT_DETAILS"

export const STORE_TABLE_ID = "STORE_TABLE_ID"
export const REMOVE_TABLE_ID = "REMOVE_TABLE_ID"

export const EVENT_DATE = "EVENT_DATE"